/*
 * Copyright (c) 2008-2019 by teambits GmbH, Darmstadt, Germany (http://www.teambits.de). All rights reserved.
 * This is CONFIDENTIAL code. Use is subject to license terms.
 */

/** The different connectivity states of this client. */
var NetworkStatus = {
	/** OK: 0 */
	CONNECTED: {code: 0, name: "CONNECTED"},
	/** Warning: 1 */
	INTERRUPTED: {code: 1, name: "INTERRUPTED"},
	/** Error: 2 */
	DISCONNECTED: {code: 2, name: "DISCONNECTED"}
};

if (typeof module === "object") {
	module.exports = NetworkStatus;
}
